var _rect, _mask, _g, _mask2, _g2, _mask3, _g3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPayPal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#paint0_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 21,
    width: 50,
    height: 59
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 21H74.3068V79.181H25V21Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.678,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4339 35.7817C70.1438 31.2554 69.4291 28.1762 66.9811 25.3863C64.2859 22.3148 59.4171 20.9992 53.1871 20.9992H35.1045C34.4882 20.9993 33.8922 21.2194 33.4238 21.6199C32.9553 22.0203 32.6452 22.5748 32.5492 23.1836L25.019 70.9312C24.9841 71.1528 24.9976 71.3794 25.0586 71.5953C25.1196 71.8111 25.2267 72.0112 25.3724 72.1818C25.5182 72.3523 25.6992 72.4892 25.9029 72.5831C26.1066 72.677 26.3283 72.7256 26.5527 72.7256H37.7161L36.9457 77.6116C36.915 77.8054 36.9267 78.0036 36.98 78.1924C37.0333 78.3812 37.1269 78.5563 37.2544 78.7054C37.3819 78.8546 37.5402 78.9743 37.7184 79.0564C37.8966 79.1385 38.0905 79.1809 38.2868 79.1808H47.6967C48.8108 79.1808 49.7589 78.3708 49.9326 77.2709L50.025 76.7921L51.7975 65.551L51.9118 64.93C51.9959 64.3975 52.2673 63.9126 52.677 63.5623C53.0868 63.2121 53.6081 63.0196 54.1471 63.0194H55.5546C64.6705 63.0194 71.8084 59.3157 73.8938 48.6056C74.7655 44.1297 74.3145 40.3945 72.0105 37.7681C71.313 36.9734 70.446 36.3162 69.4345 35.7811",
    fill: "white"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 21,
    width: 45,
    height: 52
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 21H69.6946V72.7258H25V21Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5332 35.8415C43.6171 35.309 43.8883 34.8239 44.2981 34.4736C44.708 34.1234 45.2294 33.9309 45.7685 33.931H59.9429C61.6223 33.931 63.188 34.0406 64.6197 34.2717C65.0286 34.3369 65.4268 34.4128 65.8132 34.4987C66.3746 34.6218 66.9292 34.7737 67.4749 34.9538C68.15 35.1749 68.8055 35.4518 69.4346 35.7817C70.144 31.2554 69.4287 28.1756 66.9812 25.3863C64.2867 22.3148 59.4173 20.9992 53.1879 20.9992H35.1052C34.4888 20.9992 33.8927 21.2192 33.4241 21.6197C32.9555 22.0201 32.6453 22.5747 32.5493 23.1836L25.0197 70.9312C24.9848 71.1528 24.9983 71.3793 25.0593 71.5951C25.1202 71.811 25.2273 72.011 25.373 72.1816C25.5186 72.3521 25.6996 72.489 25.9032 72.5829C26.1069 72.6769 26.3285 72.7255 26.5528 72.7256H37.7168L40.5204 54.9434L43.5326 35.8415H43.5332Z",
    fill: "white"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 21,
    width: 45,
    height: 52
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 21H69.6946V72.7258H25V21Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.696,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4339 35.7817C70.1438 31.2554 69.4291 28.1762 66.9811 25.3863C64.2859 22.3148 59.4171 20.9992 53.1871 20.9992H35.1045C34.4882 20.9993 33.8922 21.2194 33.4237 21.6199C32.9553 22.0203 32.6452 22.5748 32.5492 23.1836L25.019 70.9312C24.9841 71.1528 24.9976 71.3794 25.0586 71.5953C25.1196 71.8111 25.2267 72.0112 25.3724 72.1818C25.5182 72.3523 25.6992 72.4892 25.9029 72.5831C26.1066 72.677 26.3283 72.7256 26.5527 72.7256H37.7161L40.5203 54.9434L40.4332 55.5005C40.5273 54.8926 40.8358 54.3385 41.3027 53.9381C41.7697 53.5378 42.3645 53.3176 42.9796 53.3173H48.2851C58.7054 53.3173 66.8649 49.0838 69.249 36.8407C69.3201 36.478 69.3799 36.1272 69.4339 35.7817Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 100,
    y1: 50,
    x2: 0,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009CDE"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayPal);
export default __webpack_public_path__ + "static/media/PayPal.1d4180928be9740e5d659ccbafcb624c.svg";
export { ForwardRef as ReactComponent };